import styled from '@emotion/styled'

import { CategoryBreadcrumb } from '@/components/CategoryBreadcrumb'
import { BodyM, Typography } from '@/components/Typography'
import { getFormattedDates } from '@/core/utils/dom/getFormattedDate'
import { sanitizeUrl } from '@/core/utils/dom/security'
import type { BlogModelArticleField, CardArticleEntryData } from '@/models'
import { CONFIG } from '@/styles/emotion.config'

const BlogHeroCarrosselItemStyles = styled.a<Pick<BlogModelArticleField, 'image'>>(
  (props) => `
  position: relative;
  display: block;
  width: 100%;
  height: 300px;
  background: no-repeat top;
  background-size: cover;
  background-image: url(${props.image.small});

  &:before {
    content: "";
    background-color: rgba(0,0,0,.5);
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
  }

  .blog-hero__infos{
    margin-top: 0.5rem;

      span:first-of-type {
        margin-right: 1rem;
      }
  }


  ${CONFIG.media.xlg} {
    background-image: url(${props.image.large});
    height: 25rem;

    .blog-hero__title {
      max-width: 60%;
    }
  }
`,
)

interface Props {
  item: CardArticleEntryData
  index?: number
}

const BlogHeroCarrosselItem = ({ item, index }: Props) => {
  const { data, lastUpdated, createdDate } = item
  const { article, url } = data
  const category = data.category && data.category.value?.data

  const date = lastUpdated || createdDate
  const formattedDate = (date && getFormattedDates(date)) || undefined

  return (
    <BlogHeroCarrosselItemStyles
      image={article.image}
      href={sanitizeUrl(url)}
      aria-labelledby={`bc-title-${index} bc-date-${index}`}
    >
      <div className="blog-hero__content ecs-container">
        {category && (
          <CategoryBreadcrumb category={category} color="light-solid" noHref ariaHidden />
        )}
        <Typography
          className="blog-hero__title"
          id={`bc-title-${index}`}
          color="light-solid"
          modifier="heading-l"
          aria-label={`Título: ${article.title},`}
        >
          {article.title}
        </Typography>

        <BodyM id={`bc-date-${index}`} className="blog-hero__infos" color="light-solid">
          <span aria-label={`publicado em ${formattedDate?.accessible}`}>
            {formattedDate?.visually}
          </span>
          <span>Time Serasa</span>
        </BodyM>
      </div>
    </BlogHeroCarrosselItemStyles>
  )
}

export default BlogHeroCarrosselItem
